import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donations/donations";

export const Route = createFileRoute("/admin/_donations/donations")({
  component: Page,
});
